import React from 'react';
import Layout from '../components/layout/Layout';
import MyServices from '../components/myservices/MyServices';
import WhatIDo from '../components/whatido/WhatIDo';

function Services() {
  return (
    <Layout>
      <div className='header-service-container'>
        <h1>Web Design Services</h1>
        <>
        <p>Using the latest in web design technologies i use UX/UI design for front-end development</p>
        </>
      </div>
      <div className="service-wrapper">
        <MyServices />
        <WhatIDo />
      </div>
    </Layout>
  )
}

export default Services;